module.exports = "#version 300 es\nprecision highp float;\n\nin vec4 fs_Col;\nin vec4 fs_Pos;\n\nin vec4 fs_Normal;\nout vec4 out_Col;\n\nvec3 lightPos = vec3(10.0);\n\nvoid main()\n{\n    float dist = 1.0 - (length(fs_Pos.xyz) * 2.0);\n    vec3 norCol = (vec3(fs_Normal) + vec3(1.0)) * 0.5;\n    out_Col = vec4(norCol, 1.0);\n    vec3 lightDir = normalize(lightPos - vec3(fs_Pos));\n    float NdotL = max(dot(lightDir, vec3(fs_Normal)), 0.0);\n    float diffuse = max(0.2, NdotL);\n    out_Col = vec4(mix(vec3(diffuse), norCol, diffuse), 1.0);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/lambert-frag.glsl
// module id = 79
// module chunks = 0